module.exports = __webpack_public_path__ + "img/img_size_02.33f194d6.png";